import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';

const FieldRegisterEmail = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'register-form-email',
    defaultMessage: 'Email'
  });
  const placeholder = intl.formatMessage({
    id: 'default-placeholder',
    defaultMessage: 'Write here'
  });
  const [field, meta, helper] = useField<string>({name: 'email'});

  return (
    <InputText
      {...field}
      {...meta}
      variant={'full'}
      id={field.name}
      label={labelText}
      defaultValue={field.value}
      placeholder={placeholder}
      onChange={(e) => helper.setValue(e.target.value.replace(/\s/g, ''))}
      onKeyDown={(e) => {
        if (e.key === ' ') {
          e.preventDefault();
        }
      }}
    />
  );
};

export default FieldRegisterEmail;
